<template>
  <div class="payment-container">
    <!-- 商户信息 -->
    <header>
      <img :src="cash_point.logoUrl || require('@/assets/ic-org.png')" alt="商户Logo" class="merchant-logo" />
      <div class="merchant-info">
        <h1>{{ cash_point.merchantName }}</h1>
        <p>{{ cash_point.equipmentName }}</p>
      </div>
    </header>
    <div class="amount-input">
      <label for="amount">消费金额</label>
      <div class="input-box">
        <small v-if="amount">¥</small>
        {{ amount ? amount : '请输入金额' }}
        <!-- <input type="text" id="amount" v-model="amount" placeholder="请输入金额"> -->
      </div>
    </div>

    <!-- 自定义键盘 -->
    <div class="custom-keyboard">
      <div class="left">
        <button v-for="key in keys" :key="key" @click="handleKeyPress(key)">
          {{ key }}
        </button>
      </div>
      <div class="right">
        <button @click="clearInput()">清除</button>
        <button @click="handlePay()" class="pay-btn">确认<br />支付</button>
      </div>
    </div>
    <!-- </main> -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      cashPointId: localStorage.getItem('cashPointId') || null,
      appId: localStorage.getItem('appId') || null,
      uuid: localStorage.getItem('uuid') || null,
      wxmessage: localStorage.getItem('wxmessage'),
      amount: '',
      message: '',
      error: null,
      loading: true,
      isFocused: false, // 用于跟踪输入框是否获得焦点
      cash_point: {},
      keys: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.'], // 键盘按键布局
    }
  },
  mounted () {
    let viewport = document.querySelector('meta[name=viewport]')
    viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no')

    // 动态加载微信JS-SDK
    const wxpayScript = document.createElement('script')
    wxpayScript.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
    wxpayScript.onload = () => {
      console.log('微信JS-SDK加载成功')
    }
    document.body.appendChild(wxpayScript)

    // 动态加载支付宝JS-SDK
    const alipayScript = document.createElement('script')
    alipayScript.src = 'https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.min.js'
    alipayScript.onload = () => {
      console.log('支付宝JS-SDK加载成功')
    }
    document.body.appendChild(alipayScript)

    this.getCashierPoint()
  },
  methods: {
    handleKeyPress (key) {
      this.amount += key
    },
    clearInput () {
      this.amount = ''
    },
    async getCashierPoint () {
      const response = await axios.get(`/api/business/cashierEquipment/` + this.cashPointId)
      console.log(response)
      this.cash_point = response.data.data
      console.log(this.cash_point, "this.cash_point")
    },
    async handlePay () {
      if (!this.amount || isNaN(this.amount)) {
        this.message = '请输入有效的金额'
        alert(this.message)
        return
      }
      if (!Number(this.amount)) {
        console.log(Number(this.amount), "Number(this.amount)");
        this.message = '金额不能为0'
        alert(this.message)
        return
      }
      if (Number(this.amount) > 80000) {
        this.message = '输入金额不能超过80000'
        alert(this.message)
        return
      }


      const userAgent = navigator.userAgent.toLowerCase()
      if (userAgent.match(/micromessenger/i)) {
        // 微信浏览器
        try {
          const wechatConfigData = await this.createWechatPayOrder(this.amount)
          this.wechatConfig(wechatConfigData.app_id, wechatConfigData.time_stamp, wechatConfigData.nonce_str, wechatConfigData.pay_sign)

          // 等待微信JS-SDK配置完成后再调起支付
          window.wx.ready(() => {
            invokeWeChatPay(wechatConfigData)
          })
        } catch (error) {
          console.log('调起支付失败', error.response.data)
          this.message = error.response.data.message || '调起支付失败，请稍后再试'
          alert(this.message)
        }
      } else if (userAgent.match(/alipay/i)) {
        // 支付宝浏览器
        try {
          const alipayConfigData = await this.createAlipayOrder(this.amount)

          if (window.AlipayJSBridge) {
            this.invokeAlipay(alipayConfigData)
          } else {
            document.addEventListener('AlipayJSBridgeReady', this.invokeAlipay, false)
          }
        } catch (error) {
          console.error('调起支付失败', error)
          this.message = error.response.data.message || '调起支付失败，请稍后再试'
          alert(this.message)
        }
      } else {
        this.message = '请在微信或支付宝客户端内打开此页面'
        alert(this.message)
      }
    },

    async createAlipayOrder (amount) {
      const config = { headers: { uuid: this.uuid } }
      const response = await axios.post(
        `/api/miniapp/payments`,
        {
          payment: {
            platform: 'cash_account',
            cash_point_id: this.cashPointId,
            paid_amount: amount,
            payment_method: 'alipay',
          },
        },
        config
      )
      return response.data.data
    },

    async invokeAlipay (payParams) {
      window.AlipayJSBridge.call(
        'tradePay',
        {
          tradeNO: payParams.trade_no,
        },
        function (data) {
          if ('9000' == data.resultCode) {
            alert('支付成功')
          }else if ('6001' == data.resultCode){
            alert('用户取消支付')
            cancelRequest(payParams.id)
          }
        }
      )
    },

    wechatConfig (appId, timestamp, nonceStr, signature) {
      if (!appId || !timestamp || !nonceStr || !signature) {
        console.error('Invalid config parameters:', { appId, timestamp, nonceStr, signature })
        return
      }

      window.wx.config({
        debug: false,
        appId: appId,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: ['chooseWXPay'],
        beta: true, // 如果需要支持 iOS 设备，请设置为 true
      })

      window.wx.ready(function () {
        console.log('微信JS SDK配置成功')
      })

      window.wx.error(function (res) {
        console.error('微信JS SDK配置失败', res)
      })
    },

    async invokeWechatPay1 (amount) {
      try {
        // 获取支付参数
        const payParams = await this.createWechatPayOrder(amount)
        console.log('🐯🐯🐯')
        console.log(payParams.data)
        console.log(payParams.data.time_stamp)
        // 配置微信JS SDK
        this.wechatConfig(payParams.data.time_stamp, payParams.data.nonce_str, payParams.data.pay_sign)
        // 调起微信支付
        window.wx.chooseWXPay({
          timestamp: payParams.data.time_stamp, // 支付签名时间戳
          nonceStr: payParams.data.nonce_str, // 支付签名随机串
          package: payParams.data.package, // 统一支付接口返回的prepay_id参数值
          signType: payParams.data.sign_type, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: payParams.data.pay_sign, // 支付签名
          success: function (res) {
            // 支付成功后的回调函数
            console.log('支付成功', res)
            alert('支付成功')
          },
          fail: function (res) {
            // 支付失败后的回调函数
            console.error('支付失败', res)
            alert('支付失败')
          },
        })
      } catch (error) {
        console.error('调起支付失败', error)
        throw new Error('调起支付失败')
      }
    },

    async createWechatPayOrder (amount) {
      const config = { headers: { uuid: this.uuid } }
      const response = await axios.post(
        `/api/miniapp/payments`,
        {
          payment: {
            cash_point_id: this.cashPointId,
            paid_amount: amount,
            payment_method: 'wxpay',
          },
        },
        config
      )
      console.log(response)
      return response.data.data
    },
  },
}
// 使用 WeixinJSBridge.invoke 调起支付
function invokeWeChatPay (payParams) {
  console.log(payParams)

  if (!window.WeixinJSBridge) {
    console.error('WeixinJSBridge is not available')
    return
  }

  window.WeixinJSBridge.invoke(
    'getBrandWCPayRequest',
    {
      appId: payParams.app_id, // 公众号名称，由商户传入
      timeStamp: payParams.time_stamp, // 时间戳，自1970年以来的秒数
      nonceStr: payParams.nonce_str, // 随机串
      package: payParams.package, // 统一下单接口返回的 prepay_id 参数值
      signType: payParams.sign_type, // 微信签名方式
      paySign: payParams.pay_sign, // 微信签名
    },
    function (res) {
      this.message = res
      localStorage.setItem('wxmessage', res) // 存储openid
      console.log(res, '( ^_^ )');
      // alert(res + '!!!')
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        alert('支付成功')
      } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
        alert('用户取消支付')
        cancelRequest(payParams.id)
      } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
        alert('支付失败')
      }
      console.log('支付结果:', res)
    }
  )
}
async function cancelRequest (id) {
  const config = { headers: { uuid: localStorage.getItem('uuid') } }
  const response = await axios.put(
    `/api/miniapp/payments/${id}/cancel`,
    {},
    config
  )
  console.warn(response)
}
</script>
<style>
body {
  margin: 0;
  padding: 0;
  background-color: #f3f4f5;
}

.payment-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

header {
  display: flex;
  justify-content: space-between;
  height: 50px;
  width: 90%;
  margin-bottom: 20px;
  align-items: center;
}

.merchant-logo {
  display: flex;
  flex: 0 0 50px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.merchant-info {
  display: flex;
  flex: 1 1 auto;
  text-align: left;
  flex-direction: column;
  padding-left: 12px;
}

.merchant-info h1 {
  font-size: 16px;
  margin: 0px;
}

.merchant-info p {
  font-size: 14px;
  font-weight: normal;
  margin: 0;
}

.amount-input {
  width: 90%;
  margin: 20px auto;
  background-color: #fff;
  border-radius: 10px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.amount-input label {
  flex: 0 0 80px;
  text-align: right;
  color: #a5a5a5;
}

.input-box {
  display: flex;
  padding-right: 15px;
  font-size: 18px;
  color: #000;
  align-items: center;
}

.input-box small {
  margin-right: 4px;
}

.custom-keyboard {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
}

.custom-keyboard .left {
  flex: 0 0 75%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
}

.custom-keyboard .right {
  flex: 0 0 25%;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.custom-keyboard button {
  padding: 0 15px;
  font-size: 18px;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
  background-color: #fff;
  border: none;
  outline: none;
  color: #333;
  transition: background-color 0.3s ease;
}

.custom-keyboard .left button:nth-child(10) {
  grid-column: span 2;
}

.custom-keyboard .right button {
  border-left: 1px solid #f3f4f5;
}

.custom-keyboard button:hover {
  background-color: #d0d0d0;
}

.custom-keyboard button.confirm-payment {
  grid-column: span 3;
  color: white;
}

.custom-keyboard button.pay-btn {
  border-top: 1px solid #f3f4f5;
  background-color: green;
  color: white;
  height: 179px;
  line-height: 30px;
}
</style>
